import { render } from "./LatestNews.vue?vue&type=template&id=b45b952a&scoped=true&ts=true"
import script from "./LatestNews.vue?vue&type=script&lang=ts"
export * from "./LatestNews.vue?vue&type=script&lang=ts"

import "./LatestNews.vue?vue&type=style&index=0&id=b45b952a&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45b952a"]])

export default __exports__